export default "__VITE_ASSET__BlsggbUq__"